const ENV = process.env.REACT_APP_ENV || 'production';

const Endpoints = (env: string = ENV) => {
    const isTestEnv = env === 'test';

    return {
        AUTH_URL: `https://api${isTestEnv ? '-test' : ''}.parentwiser.com/auth`,
        APPOINTMENT_URL: `https://api${isTestEnv ? '-test' : ''}.parentwiser.com/appointment`,
        USER_URL: `https://api${isTestEnv ? '-test' : ''}.parentwiser.com/user`,
        NOTIFICATION_URL: `https://api${isTestEnv ? '-test' : ''}.parentwiser.com/notification`,
        PAYMENT_URL: `https://api${isTestEnv ? '-test' : ''}.parentwiser.com/payment`,
        CONTENT_URL: `https://api${isTestEnv ? '-test' : ''}.parentwiser.com/content`,
    } as const;
};

type EndpointKeys = keyof ReturnType<typeof Endpoints>;

export const getEndpointUrl = (service: EndpointKeys) => {
    const endpoints = Endpoints();
    return endpoints[service];
};
